import { defineProvider } from '@nuxt/image/runtime';

export default defineProvider<{ baseURL?: string }>({
  getImage(src) {
    let reconstructedUrl: URL;
    if (src.startsWith('http')) {
      reconstructedUrl = new URL(src);
      const { host, hostname } = new URL(
        useRuntimeConfig().public.kenticoMedia,
      );
      Object.assign(reconstructedUrl, { host, hostname });
    } else
      reconstructedUrl = new URL(src, useRuntimeConfig().public.kenticoMedia);

    return { url: reconstructedUrl.toString() };
  },
});
